(function($) {
    let url = 'https://api.instagram.com/v1/users/self/media/recent/?access_token=6898214476.a837ceb.207c1f8f382c4cf995341b8faee1a8ce';

    fetch(url)
        .then(res => res.json())
        .then((out) => {
            var arr = out.data;

            arr.forEach(function(entry) {
                $("#instagram").append('<img src="' + entry.images.standard_resolution.url + '">');
            })
        })
        .catch(err => { throw err });
})(jQuery);